/**
 * A string kept per browser in localStorage.
 *
 * Storage can be blocked (private mode, a locked-down browser, a full
 * quota), and a browser that forbids it throws on the `localStorage` getter
 * itself, so the lookup happens inside the `try` rather than in a default
 * argument. Nothing stored this way is more than a convenience, so a failed
 * read is null and a failed write is logged, never thrown. `storedFlag.ts`
 * builds its yes/no preference on top of this.
 */

export type ValueStorage = Pick<Storage, 'getItem' | 'setItem'>

/** `storage` is injected by the tests (vitest runs without a window). */
export function readStoredValue(key: string, storage?: ValueStorage): string | null {
  try {
    return (storage ?? localStorage).getItem(key)
  } catch (error) {
    console.warn(`localStorage read failed for ${key}:`, error)
    return null
  }
}

export function writeStoredValue(key: string, value: string, storage?: ValueStorage): void {
  try {
    ;(storage ?? localStorage).setItem(key, value)
  } catch (error) {
    console.warn(`localStorage write failed for ${key}:`, error)
  }
}
